import { ReactElement } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import RelaxWoman from 'components/atoms/images/relaxWoman';
import FreePlatformCto, {
  FreePlatformCtoProps,
} from 'components/molecules/candidates/freePlatformCto';

export type FreePlatformProps = FreePlatformCtoProps;

const FreePlatform = ({
  freePlatformBadge,
  freePlatformTitle,
  freePlatformButton,
  freePlatformButtonIcon,
  formRef,
}: FreePlatformCtoProps): ReactElement => (
  <Box bg='primary.500' w='100%' pt='20'>
    <Flex
      justifyContent='center'
      alignItems='center'
      flexDir={['column-reverse', 'column-reverse', 'row', 'row']}
    >
      <RelaxWoman
        w={['255px', '255px', '525px', '525px']}
        h={['300px', '300px', '600px', '600px']}
        layout='fill'
        minH='100%'
        px={8}
        position='relative'
      />

      <FreePlatformCto
        freePlatformBadge={freePlatformBadge}
        freePlatformTitle={freePlatformTitle}
        freePlatformButton={freePlatformButton}
        freePlatformButtonIcon={freePlatformButtonIcon}
        formRef={formRef}
      />
    </Flex>
  </Box>
);

export default FreePlatform;
